import Head from 'next/head';
import { FC } from 'react';

export interface ProductMicrodata {
  images: string;
  price: number;
}

export interface ProductAggregatorDataProps {
  products: ProductMicrodata[];
  category: string;
}

const makeProductAggregateSchema = (products: ProductMicrodata[], category: string) => {
  const productPrices = products.map(product => product.price);
  const productImages = products.map(product => product.images);

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    'name': category,
    'image': productImages,
    'description': '',
    'brand': {
      '@type': 'Brand',
      'name': 'Veroo Cafés Especiais',
    },
    'offers': {
      '@type': 'AggregateOffer',
      'offerCount': products.length,
      'lowPrice': `${Math.min(...productPrices)}`,
      'highPrice': `${Math.max(...productPrices)}`,
      'priceCurrency': 'BRL',
    },
  };
};

export const ProductAggregatorData: FC<ProductAggregatorDataProps> = ({ products, category }) => {
  return (
    <Head>
      <script
        key={`Veroo-Loja-${category}`}
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(makeProductAggregateSchema(products, category)),
        }}
      />
    </Head>
  );
};
